import { type orderColumnPreferences } from "~/features/orderbook/models/orderbookModels";

export const parsePreferences = (
  preferences: orderColumnPreferences[] | string | undefined,
): orderColumnPreferences[] => {
  if (!preferences) {
    return [];
  }

  if (typeof preferences === "string") {
    try {
      return JSON.parse(preferences);
    } catch {
      return [];
    }
  }

  return preferences;
};

export const toColumnPreferences = <T extends string | orderColumnPreferences>(
  value: string | string[] | null | orderColumnPreferences[] | undefined,
): T[] => {
  if (value == null) {
    return [] as T[];
  }

  if (Array.isArray(value)) {
    return value as T[];
  }

  try {
    const parsed = JSON.parse(value as string);
    return (Array.isArray(parsed) ? parsed : []) as T[];
  } catch {
    return (value as string).split(",").filter((v) => v !== "") as T[];
  }
};
